import { FunctionComponent } from 'react';
import PageSidebar from 'components/PageSidebar';
import PrivatePage from './PrivatePage';
import { faList, faPuzzlePiece, faStar, faListCheck } from '@fortawesome/pro-light-svg-icons';
import { useHistory, useLocation } from 'react-router-dom';
import { MembershipsPath, ServicesPath } from 'routes/Paths';
import MembershipsComponent from 'components/Memberships';
import { useFilteredServicesNavigation } from 'utils/PageSidebarUtils';

interface ServicesProps {
    create: string;
}

const PrimaryItem = {
    icon: faList,
    title: 'Primary Services',
    key: 'primary'
};

const AddOnsItem = {
    icon: faPuzzlePiece,
    title: 'Add-Ons',
    key: 'add_ons'
};

const MembershipsItem = {
    icon: faStar,
    title: 'Memberships',
    key: 'memberships'
};

const EvaluationItem = {
    icon: faListCheck,
    title: 'Evaluation',
    key: 'evaluation'
};

export const Memberships: FunctionComponent<ServicesProps> = props => {
    const { selectedKey, setSelectedKey, sidebarItems } = useFilteredServicesNavigation('memberships');

    const sidebar = (
        <PageSidebar
            title="Services"
            items={sidebarItems}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
        />
    );

    return (
        <PrivatePage
            title="Memberships - Cuddles"
            pageName="/memberships"
            pageSidebar={sidebar}
        >
            <MembershipsComponent />
        </PrivatePage>
    );
};

export default Memberships;
